import { useCallback, useEffect, useReducer } from "react";
import { View, Text, StyleSheet, FlatList, ActivityIndicator, TouchableOpacity } from "react-native";
import Header from "../../components/Header";
import Colors from "../../constants/Colors";
import Input from "../../components/Input";
import { useSelector } from "react-redux";
import filter from "lodash.filter";
import axios from "axios";
import Config from "../../constants/Config";
import { logOut } from "../../components/Functions";

const SEARCH = "SEARCH";
const SET_LOADING = "SET_LOADING";
const SET_CUSTOMERS = "SET_SITES";
const formReducer = (state, action) => {
  switch (action.type) {
    case SEARCH:
      return {
        ...state,
        values: {
          ...state.values,
          data: action.data,
          query: action.query,
        },
      };
    case SET_LOADING:
      return {
        ...state,
        values: {
          ...state.values,
          loading: action.loading,
        },
      };
    case SET_CUSTOMERS:
      return {
        ...state,
        values: {
          ...state.values,
          customers: action.data,
        },
      };
    default:
      return state;
  }
};

const CustomersListScreen = (props) => {
  const token = useSelector((store) => store.user.token);
  const [formState, dispatchFormState] = useReducer(formReducer, {
    values: {
      data: [],
      customers: [],
      loading: false,
    },
  });

  const getCustomersList = async () => {
    const url = Config.aioUrl + "/customer/list";
    let reqHedear = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    };
    dispatchFormState({ type: SET_LOADING, loading: true });
    axios({
      method: "post",
      url: url,
      headers: reqHedear,
    })
      .then(function (response) {
        if (response.data.code == 401) {
          alert("نیاز است مجددا به سیستم ورود کنید.");
          logOut();
        }
        dispatchFormState({ type: SET_CUSTOMERS, data: response.data.data });
        dispatchFormState({ type: SET_LOADING, loading: false });
      })
      .catch(function (error) {
        dispatchFormState({ type: SET_LOADING, loading: false });
      });
  };

  useEffect(() => {
    const focused = props.navigation.addListener("focus", () => {
      getCustomersList();
    });

    return focused;
  }, [props.navigation]);

  const handleSearch = useCallback(
    (id, text) => {
      const contains = (item, query) => {
        if (item.id.includes(query) || item.first_name.includes(query) || item.last_name.includes(query) || item.mobile.includes(query)) {
          return true;
        }
        return false;
      };
      const data = filter(formState.values.customers, (item) => contains(item, text));
      dispatchFormState({ type: SEARCH, data, query: text });
    },
    [dispatchFormState, formState.values.customers]
  );
  return (
    <View style={styles.wrapper}>
      <Header title="لیست مشتریان" noBack />

      <Input label="به دنبال چه می گردی؟" id="search" onChange={handleSearch} maxLength={20} validity />
      <Text
        style={{
          color: Colors.text,
          fontFamily: "Iransans-Medium",
          fontSize: 14,
          marginBottom: 10,
          marginTop: 30,
        }}
      >
        {formState.values.data.length} مورد یافت شد
      </Text>
      {!formState.values.loading && (
        <FlatList
          showsVerticalScrollIndicator={false}
          data={formState.values.data}
          keyExtractor={(item) => item.id}
          renderItem={(item) => (
            <TouchableOpacity
              style={{
                backgroundColor: "#F2F2F2",
                width: "100%",
                paddingHorizontal: 15,
                paddingVertical: 20,
                borderRadius: 15,
                marginTop: 15,
              }}
              onPress={() => {
                props.navigation.navigate("Customer", { id: item.item.id });
              }}
            >
              <View style={{ flexDirection: "row-reverse", justifyContent: "space-between" }}>
                <View>
                  <Text style={{ fontFamily: "IranSans-Regular", fontSize: 14, color: Colors.text }}>
                    {item.item.first_name + " " + item.item.last_name}
                  </Text>
                </View>
                <View>
                  <Text style={{ fontFamily: "IranSans-Regular", fontSize: 14, color: Colors.text }}>{item.item.mobile}</Text>
                </View>
              </View>
            </TouchableOpacity>
          )}
        />
      )}
      {formState.values.loading && (
        <View>
          <ActivityIndicator size="large" color={Colors.primary} />
        </View>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  wrapper: {
    paddingHorizontal: 25,
    height: "100%",
    overflow: "hidden",
    backgroundColor: Colors.bg,
  },
  headerText: {
    fontFamily: "IranSans-Medium",
    fontSize: 14,
    color: "#fff",
  },
});

export const screenOptions = {
  headerShown: false,
  drawerPosition: "right",
};

export default CustomersListScreen;
